<script>
import { mapActions, mapGetters } from 'vuex'
import FILTRO_EMPTY from '@/models/filtro'

export default {

  async created () {
    this.usuario = await this.getUsuario()
  },

  data () {
    return {
      usuario: null
    }
  },

  methods: {
    ...mapActions({
      getCadastrosProvisorios: 'cadastroProvisorio/getByFilter',
      getCadastrosGeo: 'analiseGeo/getByFilter'
    }),
    ...mapGetters({
      getUsuario: 'auth/usuarioLogado'
    }),
    async init () {
      const data = await this.buscar()
      this.items = data.content
      this.totalElements = data.totalElements
    },
    async pesquisar (filtro) {
      this.filtro = { ...filtro, pagina: 0, caixa: this.filtro.caixa }
      const data = await this.buscar()
      this.items = data.content
      this.totalElements = data.totalElements
    },
    async changePage (newPage) {
      this.filtro.pagina = newPage - 1
      const data = await this.buscar()
      this.items = data.content
      this.totalElements = data.totalElements
    },
    async sort (item) {
      this.filtro.ordem = item.ordem
      this.filtro.ordemDirecao = item.tipo
      const data = await this.buscar()
      this.items = data.content
      this.totalElements = data.totalElements
    },
    async buscar () {
      switch (this.filtro.caixa) {
        case 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO':
          return this.getCadastrosGeo({ dados: { ...this.filtro } })
        default:
          return this.getCadastrosProvisorios({ dados: { ...this.filtro } })
      }
    },
    async clear (item) {
      this.filtro = FILTRO_EMPTY(this.filtro.caixa)
      this.filtro.pagina = 0
      const data = await this.buscar()
      this.items = data.content
      this.totalElements = data.totalElements
    },
    async refresh (item) {
      let data = null
      if (item) {
        item.pagina = 0
      }
      data = await this.buscar()
      this.items = data.content
      this.totalElements = data.totalElements
    },
    executar (item) {
      this[item.acao](this, item)
    },
    showEditarCadastroGeo (item) {
      return item.status === 'EM_ANDAMENTO'
    },
    showInserirNumeroRecibo (item) {
      return item.status === 'AGUARDANDO_NUMERO_RECIBO'
    },
    showVisualizarCadastroGeo (item) {
      return item.status !== 'EM_ANDAMENTO'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/receptor/ba/BaseFiltroCadastroProvisorio.vue